export default {
  //get all GROUPs
  GET_SUPERADMIN_GROUPS_REQUEST: "GET_SUPERADMIN_GROUPS_REQUEST",
  GET_SUPERADMIN_GROUPS_SUCCESS: "GET_SUPERADMIN_GROUPS_SUCCESS",
  GET_SUPERADMIN_GROUPS_FAIL: "GET_SUPERADMIN_GROUPS_FAIL",

  //edit GROUPs
  EDIT_SUPERADMIN_GROUP_REQUEST: "EDIT_SUPERADMIN_GROUP_REQUEST",
  EDIT_SUPERADMIN_GROUP_SUCCESS: "EDIT_SUPERADMIN_GROUP_SUCCESS",
  EDIT_SUPERADMIN_GROUP_FAIL: "EDIT_SUPERADMIN_GROUP_FAIL",

  //create GROUP
  CREATE_SUPERADMIN_GROUP_REQUEST: "CREATE_SUPERADMIN_GROUP_REQUEST",
  CREATE_SUPERADMIN_GROUP_SUCCESS: "CREATE_SUPERADMIN_GROUP_SUCCESS",
  CREATE_SUPERADMIN_GROUP_FAIL: "CREATE_SUPERADMIN_GROUP_FAIL",

  DELETE_SUPERADMIN_GROUP_REQUEST: "DELETE_SUPERADMIN_GROUP_REQUEST",
  DELETE_SUPERADMIN_GROUP_SUCCESS: "DELETE_SUPERADMIN_GROUP_SUCCESS",
  DELETE_SUPERADMIN_GROUP_FAIL: "DELETE_SUPERADMIN_GROUP_FAIL",

  GET_SUPERADMIN_GROUP_REQUEST: "GET_SUPERADMIN_GROUP_REQUEST",
  GET_SUPERADMIN_GROUP_SUCCESS: "GET_SUPERADMIN_GROUP_SUCCESS",
  GET_SUPERADMIN_GROUP_FAIL: "GET_SUPERADMIN_GROUP_FAIL",

  GET_PERFORMANCE_SUPERADMIN_GROUPS_REQUEST:
    "GET_PERFORMANCE_SUPERADMIN_GROUPS_REQUEST",
  GET_PERFORMANCE_SUPERADMIN_GROUPS_SUCCESS:
    "GET_PERFORMANCE_SUPERADMIN_GROUPS_SUCCESS",
  GET_PERFORMANCE_SUPERADMIN_GROUPS_FAIL:
    "GET_PERFORMANCE_SUPERADMIN_GROUPS_FAIL",
  GET_SYSTEM_SUPERADMIN_GROUPS_REQUEST: "GET_SYSTEM_SUPERADMIN_GROUPS_REQUEST",
  GET_SYSTEM_SUPERADMIN_GROUPS_SUCCESS: "GET_SYSTEM_SUPERADMIN_GROUPS_SUCCESS",
  GET_SYSTEM_SUPERADMIN_GROUPS_FAIL: "GET_SYSTEM_SUPERADMIN_GROUPS_FAIL",
  //loading
  ADD_SUPERADMIN_GROUPS_LOADING: "ADD_SUPERADMIN_GROUPS_LOADING",

  SUPERADMIN_GET_COURSE_GROUP_REQUEST: "SUPERADMIN_GET_COURSE_GROUP_REQUEST",
  SUPERADMIN_GET_COURSE_GROUP_SUCCESS: "SUPERADMIN_GET_COURSE_GROUP_SUCCESS",
  SUPERADMIN_GET_COURSE_GROUP_FAIL: "SUPERADMIN_GET_COURSE_GROUP_FAIL",
};
